module.exports = __webpack_public_path__ + "img/danger-sign.4181e5dd.svg";